import React, { useState } from "react";
import CheckboxSection from "./CheckboxSection";
import {InventoryFilterState} from '../SkinDbFilter';

export type WeaponTypesProps = {
    filters: InventoryFilterState;
    toggle: (key: keyof InventoryFilterState, val: string) => void;
    setList: (key: keyof InventoryFilterState, values: string[]) => void; // NEW
    pistols: string[];
    smg: string[];
    rifles: string[];
    snipers: string[];
    shotguns: string[];
    machineguns: string[];
    equipment: string[];
    knives: string[];
};

const WeaponTypesSection: React.FC<WeaponTypesProps> = ({
                                                            filters,
                                                            toggle,
                                                            setList,
                                                            pistols,
                                                            smg,
                                                            rifles,
                                                            snipers,
                                                            shotguns,
                                                            machineguns,
                                                            equipment,
                                                            knives,
                                                        }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="border border-gray-700 rounded-md overflow-hidden">

            {/* Header */}
            <button
                onClick={() => setOpen(!open)}
                className={`
          w-full flex justify-between items-center px-3 py-2 text-gray-300 text-sm transition
          hover:bg-gray-800/40
          ${open ? "bg-gray-800/40" : ""}
        `}
            >
                <span className="!text-[0.80rem] !font-semibold">Weapon Types</span>
                <span className="!text-[0.80rem] !font-semibold">{open ? "▲" : "▼"}</span>
            </button>

            {/* Animated wrapper */}
            <div
                className={`
          transition-all duration-300 ease-in-out overflow-hidden
          ${open ? "max-h-[9999px]" : "max-h-0"}
        `}
            >
                <div className="px-3 pb-3 pt-2 space-y-3">

                    <CheckboxSection
                        title="Pistols"
                        list={pistols}
                        selected={filters.pistols}
                        onToggle={(v) => toggle("pistols", v)}
                        onSet={(vals) => setList("pistols", vals)}
                    />

                    <CheckboxSection
                        title="SMG"
                        list={smg}
                        selected={filters.smg}
                        onToggle={(v) => toggle("smg", v)}
                        onSet={(vals) => setList("smg", vals)}
                    />

                    <CheckboxSection
                        title="Rifles"
                        list={rifles}
                        selected={filters.rifles}
                        onToggle={(v) => toggle("rifles", v)}
                        onSet={(vals) => setList("rifles", vals)}
                    />

                    <CheckboxSection
                        title="Snipers"
                        list={snipers}
                        selected={filters.snipers}
                        onToggle={(v) => toggle("snipers", v)}
                        onSet={(vals) => setList("snipers", vals)}
                    />

                    <CheckboxSection
                        title="Shotguns"
                        list={shotguns}
                        selected={filters.shotguns}
                        onToggle={(v) => toggle("shotguns", v)}
                        onSet={(vals) => setList("shotguns", vals)}
                    />

                    <CheckboxSection
                        title="Machine Guns"
                        list={machineguns}
                        selected={filters.machineguns}
                        onToggle={(v) => toggle("machineguns", v)}
                        onSet={(vals) => setList("machineguns", vals)}
                    />

                    <CheckboxSection
                        title="Equipment"
                        list={equipment}
                        selected={filters.equipment}
                        onToggle={(v) => toggle("equipment", v)}
                        onSet={(vals) => setList("equipment", vals)}
                    />

                    <CheckboxSection
                        title="Knives"
                        list={knives}
                        selected={filters.knives}
                        onToggle={(v) => toggle("knives", v)}
                        onSet={(vals) => setList("knives", vals)}
                    />

                </div>
            </div>

        </div>
    );
};

export default WeaponTypesSection;